import { render, staticRenderFns } from "./SimulationList.vue?vue&type=template&id=0c51048c&scoped=true&"
import script from "./SimulationList.vue?vue&type=script&lang=js&"
export * from "./SimulationList.vue?vue&type=script&lang=js&"
import style0 from "./SimulationList.vue?vue&type=style&index=0&id=0c51048c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c51048c",
  null
  
)

export default component.exports